export default __webpack_public_path__ + "static/media/frankhomies-gang.7497f240.png";